"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexListError = exports.IndexList = void 0;
class IndexList {
    constructor(obj) {
        this.indexes = obj;
    }
}
exports.IndexList = IndexList;
class IndexListError {
    constructor(obj) {
        for (const prop in obj) {
            this[prop] = obj[prop];
        }
    }
}
exports.IndexListError = IndexListError;
//# sourceMappingURL=IndexList.js.map